import { render, staticRenderFns } from "./AssessmentsCenter.vue?vue&type=template&id=977a88dc&scoped=true&"
import script from "./AssessmentsCenter.vue?vue&type=script&lang=ts&"
export * from "./AssessmentsCenter.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentsCenter.vue?vue&type=style&index=0&id=977a88dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977a88dc",
  null
  
)

export default component.exports